<script>
/**
 * Uma aba da fila.
 *
 * O elemento clicavel e um `<a>` SEM `href` -- e assim desde sempre, e era por
 * isso que a aba nao existia para o teclado: elemento ancora sem `href` nao
 * entra na ordem de tabulacao, nao recebe foco no clique e nao responde a
 * Enter. Quem navega sem mouse simplesmente pulava a barra inteira.
 *
 * A correcao nao troca a tag por `<button>` de proposito: `.tabs-title a` e o
 * seletor que pinta estas abas em duas folhas diferentes (a global e a da faixa
 * da conversa), e trocar o elemento levaria junto todo o desenho. O que falta
 * ao `<a>` sem `href` -- foco, papel e ativacao por tecla -- e o que entra aqui.
 *
 * DESVIO DELIBERADO do padrao `tablist` do ARIA, que pede `tabindex` movel (so
 * a aba ativa alcancavel por Tab, as setas trocando de aba): aqui TODA aba esta
 * na ordem de tabulacao, que e o comportamento pedido -- Tab anda de aba em aba
 * como em qualquer outra barra. As setas continuam funcionando por cima disso,
 * para quem espera o padrao. O `PanelTabs.vue` do painel de detalhes segue o
 * padrao movel; as duas barras divergem nisso, e e uma escolha, nao um esquecimento.
 */
export default {
  name: 'WootTabsItem',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    active() {
      return this.index === this.$parent.index;
    },

    getItemCount() {
      return this.count;
    },
  },

  methods: {
    onTabClick(event) {
      event.preventDefault();
      if (!this.disabled) {
        this.$parent.$emit('change', this.index);
      }
    },
    // Seta anda para a aba vizinha e JA TROCA, que e a ativacao automatica do
    // ARIA e o que o `PanelTabs.vue` faz. Da a volta nas pontas: quem esta na
    // ultima e aperta direita vai para a primeira, em vez de bater numa parede.
    onArrowKey(passo) {
      const fila = this.$el.parentElement;
      if (!fila) return;

      const abas = Array.prototype.slice.call(
        fila.querySelectorAll('.tabs-title > [role="tab"]')
      );
      const atual = abas.indexOf(this.$el.firstElementChild);
      if (atual === -1 || !abas.length) return;

      const alvo = abas[(atual + passo + abas.length) % abas.length];
      if (alvo) alvo.focus();
    },
  },
};
</script>

<template>
  <!-- `presentation` no <li>: o `role="tablist"` do <ul> pede `role="tab"` como
       filho DIRETO, e o item de lista no meio quebraria essa relacao. -->
  <li
    role="presentation"
    class="tabs-title"
    :class="{
      'is-active': active,
    }"
  >
    <a
      role="tab"
      :tabindex="disabled ? -1 : 0"
      :aria-selected="active ? 'true' : 'false'"
      :aria-disabled="disabled ? 'true' : 'false'"
      @click="onTabClick"
      @keydown.enter.prevent="onTabClick"
      @keydown.space.prevent="onTabClick"
      @keydown.left.prevent="onArrowKey(-1)"
      @keydown.right.prevent="onArrowKey(1)"
    >
      {{ name }}
      <div v-if="showBadge" class="badge min-w-[20px]">
        <span>
          {{ getItemCount }}
        </span>
      </div>
    </a>
  </li>
</template>
